import plugin from './src/debug.plugin.js';
export default plugin;